import { useState, useEffect, useRef, useCallback } from "react"
import ApiService from "../data/services/ApiService"

export default function useProductsData(rowsPerPage = 20) {
    const [list, setList] = useState([])
    const [filteredData, setFilteredData] = useState([])

    const [offset, setOffset] = useState(0)
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)

    const [search, setSearch] = useState('')
    const searchIdRef = useRef(0)

    // normalización
    const normalize = str =>
        str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

    const fetchProducts = useCallback(async (currentOffset = offset) => {
        setLoading(true)
        try {
            const response = await ApiService.getProducts(currentOffset, rowsPerPage)
            setList(response.data.products)
            setFilteredData(response.data.products)
            setTotalCount(response.data.count)
        } finally {
            setLoading(false)
        }
    }, [offset, rowsPerPage])

    const remoteSearch = async (keyword, currentOffset = 0) => {
        const normalized = normalize(keyword)

        // si es vacío o menos de 2 caracteres → fallback
        if (normalized.trim().length < 2) {
            setSearch('')
            await fetchProducts(currentOffset)
            return
        }

        const searchId = ++searchIdRef.current
        setSearch(normalized)
        setLoading(true)

        try {
            const response = await ApiService.searchProducts(normalized, currentOffset, rowsPerPage)

            // descartar respuestas viejas
            if (searchId !== searchIdRef.current) return

            setFilteredData(response.data.products)
            setTotalCount(response.data.count)
        } finally {
            setLoading(false)
        }
    }

    const changePage = async (page) => {
        const newOffset = page * rowsPerPage
        setOffset(newOffset)

        if (search) {
            await remoteSearch(search, newOffset)
        } else {
            await fetchProducts(newOffset)
        }
    }

    useEffect(() => {
        fetchProducts(0)
    }, [fetchProducts])

    return {
        list,
        filteredData,
        loading,
        offset,
        totalCount,
        search,
        remoteSearch,
        changePage,
        fetchProducts
    }
}
